import styled from '@emotion/styled';

export const Container = styled.div`
  h4 {
    margin: 0;
  }
  li {
    line-height: 1.5;
  }
`;